"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.jsonitoResponsePrefix = exports.defaultBranchName = exports.breakingSchemaChangesError = exports.defaultCacheSize = exports.defaultRetries = exports.rootFieldName = exports.defaultArmKey = exports.numHashBuckets = exports.fieldPathSeparator = exports.isQueryVariableKey = exports.isPartialObjectKey = exports.graphqlTypeNameKey = exports.tokenEnvironmentVariableName = exports.configFileName = exports.traceIdHeaderName = exports.prodLogsEndpointUrl = exports.prodEdgeCdnBaseUrl = exports.stagingLogsEndpointUrl = exports.stagingEdgeCdnBaseUrl = exports.localLogsEndpointUrl = exports.localEdgeWorkerBaseUrl = exports.logsCreationEndpoint = void 0;
exports.logsCreationEndpoint = "/logs";
exports.localEdgeWorkerBaseUrl = "http://localhost:3002";
exports.localLogsEndpointUrl = `http://localhost:3003${exports.logsCreationEndpoint}`;
exports.stagingEdgeCdnBaseUrl = "https://hypertune-edge-staging.b-cdn.net";
exports.stagingLogsEndpointUrl = `https://gcp-staging.fasthorse.workers.dev${exports.logsCreationEndpoint}`;
exports.prodEdgeCdnBaseUrl = "https://edge.hypertune.com";
exports.prodLogsEndpointUrl = `https://gcp.fasthorse.workers.dev${exports.logsCreationEndpoint}`;
exports.traceIdHeaderName = "x-hypertune-trace-id";
exports.configFileName = "hypertune.json";
exports.tokenEnvironmentVariableName = "HYPERTUNE_TOKEN";
exports.graphqlTypeNameKey = "__typename";
exports.isPartialObjectKey = "__isPartialObject__";
exports.isQueryVariableKey = "__isVariable";
exports.fieldPathSeparator = " > ";
exports.numHashBuckets = 10000;
exports.defaultArmKey = "default";
exports.rootFieldName = "root";
exports.defaultRetries = 10;
exports.defaultCacheSize = 250;
exports.breakingSchemaChangesError = "If you've made breaking changes to your schema like adding a new field argument, you may need to re-run code generation and fix the type errors.";
exports.defaultBranchName = "main";
exports.jsonitoResponsePrefix = "jsonito_";
//# sourceMappingURL=constants.js.map